module.exports = __webpack_public_path__ + "static/media/wp.aab74b72.png";